import { env } from "../../env";

export const API_URL = `${env.VITE_HTTP_PROTO}://${env.VITE_API_HOST}`;
export const RT_URL = `${env.VITE_RT_PROTO}://${env.VITE_RT_API_HOST}`;
export const RT_HTTP_URL = `${env.VITE_HTTP_PROTO}://${env.VITE_RT_API_HOST}`;
